import React from "react";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Box, Typography } from "@mui/material";
import { useDrag } from "react-dnd";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import { StyledFileIcon } from "../utils/Icons";
import { ComponentProps, DragType } from "../utils/types";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.light,
    width: "100%",
    padding: 8,
    marginBottom: 8,
  },

  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

const StyledDragIndicatorIcon = withStyles(DragIndicatorIcon, (theme) => ({
  root: {
    color: colors.gray,
  },
}));

const Files: React.FC<ComponentProps> = ({ componentType }) => {
  const [, drag] = useDrag({
    type: DragType.COMPONENT,
    item: () => {
      return componentType;
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const { classes } = useStyles();

  return (
    <div className={classes.root} ref={drag}>
      <Box className={classes.header}>
        <Typography
          variant="h6"
          color="textPrimary"
          style={{ marginBottom: 12 }}
        >
          Files
        </Typography>
        <StyledDragIndicatorIcon />
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection="column"
        style={{ backgroundColor: colors.white }}
        padding="12px 12px 12px 12px"
      >
        <StyledFileIcon />
        <>
          <Typography variant="body2" color="textSecondary">
            Drop your files here or upload from your device
          </Typography>
        </>
      </Box>
    </div>
  );
};

export default Files;
